import { call, put } from "redux-saga/effects";
import { takeLatest, takeEvery } from "redux-saga/effects";

import {
  GOT_STAFF_SERVICES_AND_MORE,
  GOT_CUSTOMERS_BASED_ON_FILTER,
  GET_PROFILE_FOR_CURRENT_USER,
  GOT_PROFILE_FOR_CURRENT_USER,
  GET_STAFF_SERVICES_AND_MORE,
  GET_CUSTOMERS_BASED_ON_FILTER,
  GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES,
  GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES,
  ERROR_GETTING_BOOKINGS_FOR_RESOURCE_WITHIN_DATES
} from "../appointmentStep";
import { getLocalStorageItem, getSpId, getOrgId } from "../../utils/helpers";
import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../globalError";
import { handleApiErrors, IsvalidId } from "./helpers";
import { updateTokenApi } from "./booking";

/***** SAGA START ******/
export let getStaffServicesAndMoreApi = () => {
  if (IsvalidId(getSpId())) {
    return fetch(
      `${window.APP.apiPath}api/serviceprovider/${getSpId()}?view=full`,
      {
        headers: { Authorization: getLocalStorageItem("token_authorization") }
      }
    )
      .then(response => {
        return response.json().then(result => {
          if (result.code && result.code != 200) {
            return handleApiErrors(result);
          } else {
            return result;
          }
        });
      })
      .catch(error => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

export function* loadStaffServicesAndMore(payload) {
  //this function loads the staff list into redux
  try {
    const data = yield call(getStaffServicesAndMoreApi);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_STAFF_SERVICES_AND_MORE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let getCustomersBasedOnFilterApi = ({ filter }) => {
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return handleApiErrors({ generalError: true });
  }
  if (!filter) {
    return;
  }
  return fetch(
    `${
      window.APP.apiPath
    }api/organization/${getOrgId()}/customers/search?value=${filter.toLowerCase()}`,
    {
      headers: { Authorization: getLocalStorageItem("token_authorization") }
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200 && result.code != 400) {
          return handleApiErrors(result);
        } else {
          return result || [];
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadCustomersBasedOnFilter(filter) {
  //this function loads the customers list into redux
  try {
    const data = yield call(getCustomersBasedOnFilterApi, filter);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_CUSTOMERS_BASED_ON_FILTER, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
export let getCurrentUserProfileApi = id => {
  if (IsvalidId(id)) {
    return fetch(`${window.APP.apiPath}api/users/${id}`, {
      headers: { Authorization: getLocalStorageItem("token_authorization") }
    })
      .then(response => {
        return response.json().then(result => {
          if (result.code && result.code != 200 && result.code != 400) {
            return handleApiErrors(result);
          } else {
            return result || [];
          }
        });
      })
      .catch(error => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* loadCurrentUserProfile() {
  //this function loads the customers list into redux
  try {
    const userData = yield call(updateTokenApi);

    const data = yield call(getCurrentUserProfileApi, userData.id);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_PROFILE_FOR_CURRENT_USER, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/

export let getBookingsForResourceWithinDatesApi = payload => {
  let { resourceId, startDate, endDate } = payload.data;
  if (IsvalidId(getSpId()) && IsvalidId(resourceId)) {
    return fetch(
      `${
        window.APP.apiPath
      }api/serviceprovider/${getSpId()}/resources/${resourceId}/timeline?startdate=${startDate}&enddate=${endDate}`,
      {
        headers: { Authorization: getLocalStorageItem("token_authorization") }
      }
    )
      .then(response => {
        return response.json().then(result => {
          if (result.code && result.code != 200) {
            return handleApiErrors(result);
          } else {
            return result;
          }
        });
      })
      .catch(error => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* loadBookingsForResourceWithinDates(payload) {
  //this function loads the customers list into redux
  try {
    const data = yield call(getBookingsForResourceWithinDatesApi, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      data.bookingId = payload.data.bookingId;
      data.item = payload.data.item;
      yield put({ type: GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES, data }); // Yields effect to the reducer specifying the action type and user details
      if (payload.data.cb) {
        payload.data.cb(payload.data.item);
      }
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

function* watchRequests() {
  yield* [
    takeLatest(GET_CUSTOMERS_BASED_ON_FILTER, loadCustomersBasedOnFilter),
    takeLatest(GET_STAFF_SERVICES_AND_MORE, loadStaffServicesAndMore),
    takeLatest(GET_PROFILE_FOR_CURRENT_USER, loadCurrentUserProfile),
    takeEvery(
      GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES,
      loadBookingsForResourceWithinDates
    )
  ];
}

export default [watchRequests];
